/**
 * Initialisation Sentry pour les apps Vite/React.
 * Appeler initSentry() dans main.tsx AVANT createRoot().
 */
import * as Sentry from '@sentry/react';
import type { SiteId } from './config';
import { getSentryConfig } from './config';

export type { SiteId } from './config';

export function initSentry(siteId: SiteId) {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;

  const env = import.meta.env.MODE || 'production';

  Sentry.init({
    dsn,
    ...getSentryConfig(siteId, env),
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
  });
}

export { Sentry };
